import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Shield, X } from "lucide-react";
import { useImpersonation } from "@/hooks/useImpersonation";

export const ImpersonationBanner = () => {
  const { isImpersonating, impersonatedUser, stopImpersonation } = useImpersonation();

  if (!isImpersonating || !impersonatedUser) return null;

  return (
    <Alert className="fixed top-0 left-0 right-0 z-50 rounded-none border-0 border-b-4 border-destructive bg-destructive/10 backdrop-blur-sm">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Shield className="h-5 w-5 text-destructive animate-pulse" />
          <AlertDescription className="text-sm font-semibold text-destructive">
            IMPERSONATION MODE ACTIVE: You are viewing as {impersonatedUser.full_name} ({impersonatedUser.email})
          </AlertDescription>
        </div>
        <Button
          variant="destructive"
          size="sm"
          onClick={stopImpersonation}
          className="gap-2"
        >
          <X className="h-4 w-4" />
          Stop Impersonating
        </Button>
      </div>
    </Alert>
  );
};
